import Builder from './sdk.builder';
import SquawkJS from './squawk';
import type { ListenerCallback, PublisherCallback, TransportConfig } from './utils/interfaces';
import { PresenterState, RTCState, TransportState, ErrorType } from './utils/types';
import type { GetStreamResponse, Stream } from './transports/websocket/request.manager/get.streams';
import { SquawkError } from './squawk.errors/base';
import type { Presenter } from './transports/websocket/request.manager/join.room';

export {
  Builder,
  SquawkJS,
  TransportState,
  PresenterState,
  RTCState,
  TransportConfig,
  PublisherCallback,
  ListenerCallback,
  GetStreamResponse,
  Stream,
  ErrorType,
  SquawkError,
  Presenter,
};

export default { Builder };
